// @flow
import { useEffect } from 'react';
import Debug from 'debug';
import TileLayer from 'ol/layer/Tile';
import { useMap } from '../context';

const debug = Debug('amms:modules:openlayers:layers:tile');

type Props = $ReadOnly<{
    source: {||},
    zIndex?: number
}>;

function Tile({ source, zIndex }: Props) {
    const map = useMap();

    useEffect(() => {
        let layer;
        if(map) {
            debug('Adding Tile layer with source ', source);

            layer = new TileLayer({
                source,
                zIndex
            });

            map.addLayer(layer);
        }

        return () => {
           if(map && layer) {
               debug('Removing Tile layer with source ', source);
               map.removeLayer(layer);
           }
        };
    }, [map, source, zIndex]);

    return null;
}

export default Tile;